import { render, staticRenderFns } from "./SectionsBox.vue?vue&type=template&id=e5b63f1c&scoped=true&"
import script from "./SectionsBox.vue?vue&type=script&lang=js&"
export * from "./SectionsBox.vue?vue&type=script&lang=js&"
import style0 from "./SectionsBox.vue?vue&type=style&index=0&id=e5b63f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b63f1c",
  null
  
)

export default component.exports